import styled from 'styled-components';

const SectionTitle = styled.div`
  color: var(--grey900);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export default SectionTitle;
